/* tslint:disable:max-line-length */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
//
// Library Service Modules
//
import { RtiHttpServiceModule } from '../../../lib/angular/service/rti-HttpService.module';
import { RtiHttpService } from '../../../lib/angular/service/rti-HttpService';
import { RtiJsonService } from '../../../lib/angular/service/common/rti-JsonService';
import { RtiMessageBusService } from '../../../lib/angular/service/common/rti-MessageBusService';
//
// Applicaiton Specific Shared Services(s)
//
import { ddMarketplaceInventoryService } from './common/dd-marketplace-inventory.service';
import { ddDealerOptionService } from './common/dd-dealer-option.service';
import { ddLocalSpecialService } from './common/dd-local-special.service';
import { ddProtectionProductsService } from './common/dd-protection-products.service';
import { DDMenuEnableDisableService } from './common/dd-menu-enable-disable.service';

const SERVICES = [
  ddDealerOptionService,
  ddMarketplaceInventoryService,
  ddLocalSpecialService,
  ddProtectionProductsService,
  RtiHttpService,
  RtiJsonService,
  RtiMessageBusService,
  DDMenuEnableDisableService
];

@NgModule({ imports: [RtiHttpServiceModule], providers: [provideHttpClient(withInterceptorsFromDi())] })

export class ddServiceModule {
  public static forRoot(): ModuleWithProviders<ddServiceModule> {
    return {
      ngModule: ddServiceModule,
      providers: SERVICES
    };
  }
}
